import { makeStyles } from "@material-ui/core/styles";

import { Container, Grid, Typography } from "@material-ui/core";
import React = require("react");
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: "#333",
    width: `100%`,
    position: "relative",
    overflow: "hidden",
    padding: "2em 0 ",
  },
  link: {
    fontSize: "1.25em",
    color: "#fff",
    "&:hover": {
      color: theme.palette.info.main,
    },
  },
  copylight: {
    color: "#fff",
    fontSize: "1em",
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      <Container maxWidth="lg">
        <Grid container direction="row" alignItems="center">
          <Grid item xs={12}>
            <Typography className={classes.copylight}>
              Email: ryosushichicago@gmail.com
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.copylight}>
              Phone: (312)-409-8888
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.copylight}>
              Address: 62 E Madison St, Chicago, IL 60602
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </footer>
  );
};

export default Footer;
